import i18next, { Resource, TFunction } from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEn from "./en/translation.json";
import translationsDe from "./de/translation.json";
import translationsIt from "./it/translation.json";

import { currentLanguage, fallbackLanguage } from "@newsenec/language-provider";
import { isCockpitItaly } from "@newsenec/auth-provider";

export type TranslationKey = keyof typeof translationsEn;
const resources: Resource = {
    en: {
        translation: translationsEn,
    },
    de: {
        translation: translationsDe,
    },
    it: {
        translation: translationsIt,
    },
};

export const setupI18next = (): Promise<TFunction> => {
    return i18next.use(initReactI18next).init({
        lng: isCockpitItaly() ? "it" : currentLanguage(),
        resources,
        fallbackLng: fallbackLanguage,
        interpolation: {
            escapeValue: false, // React already escapes by default
        },
    });
};
